import { motion } from 'framer-motion'

const SvgComponent = ({ transition, ...props }) => (
  <motion.svg

    initial={{
      y: '30%',
      x: '-10%',
      scale: 0.75,
      opacity: 0
    }}
    animate={{
      y: '10%',
      opacity: 1,
      transition: { ...transition }
    }}
    exit={{
      y: '30%',
      opacity: 0,
      transition: { ...transition }
    }}

    viewBox="0 0 287 251"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={62.131}
      y={21.879}
      width={149.826}
      height={209.704}
      rx={2.506}
      transform="rotate(-3.945 62.13 21.88)"
      fill="url(#3n3fyd7bya)"
    />
    <g filter="url(#tmoqtxx93b)">
      <rect
        x={88.234}
        y={49.147}
        width={101.495}
        height={7.25}
        rx={3.625}
        transform="rotate(-3.945 88.234 49.147)"
        fill="url(#autv6wi1lc)"
      />
    </g>
    <g filter="url(#3thav2ed8d)">
      <rect
        x={90.728}
        y={85.309}
        width={101.495}
        height={7.25}
        rx={3.625}
        transform="rotate(-3.945 90.728 85.31)"
        fill="url(#pynsemxl7e)"
      />
    </g>
    <g filter="url(#rr8aa7c3vf)">
      <rect
        x={92.391}
        y={109.417}
        width={101.495}
        height={7.25}
        rx={3.625}
        transform="rotate(-3.945 92.39 109.417)"
        fill="url(#b4t4wwoqjg)"
      />
    </g>
    <g filter="url(#qfot5e92xh)">
      <rect
        x={89.065}
        y={61.201}
        width={65.247}
        height={7.25}
        rx={3.625}
        transform="rotate(-3.945 89.065 61.201)"
        fill="url(#8xd6ibtbni)"
      />
    </g>
    <g filter="url(#oi2arrg9aj)">
      <rect
        x={91.56}
        y={97.363}
        width={65.247}
        height={7.25}
        rx={3.625}
        transform="rotate(-3.945 91.56 97.363)"
        fill="url(#karve70x5k)"
      />
    </g>
    <g filter="url(#hgq8oktspl)">
      <rect
        x={93.222}
        y={121.472}
        width={65.247}
        height={7.25}
        rx={3.625}
        transform="rotate(-3.945 93.222 121.472)"
        fill="url(#9ih557asrm)"
      />
    </g>
    <g filter="url(#yskqa6cxdn)">
      <rect
        x={126.45}
        width={149.826}
        height={209.704}
        rx={2.506}
        transform="rotate(11.324 126.45 0)"
        fill="url(#0a8pba9xwo)"
      />
      <g filter="url(#ku9md2gkip)">
        <rect
          x={144.451}
          y={33.179}
          width={101.495}
          height={7.25}
          rx={3.625}
          transform="rotate(11.324 144.451 33.18)"
          fill="url(#9hjoextykq)"
        />
      </g>
      <g filter="url(#i1fhrbfdar)">
        <rect
          x={137.334}
          y={68.721}
          width={101.495}
          height={7.25}
          rx={3.625}
          transform="rotate(11.324 137.334 68.721)"
          fill="url(#2ybgdiwmjs)"
        />
      </g>
      <g filter="url(#2169vrcq6t)">
        <rect
          x={132.589}
          y={92.417}
          width={101.495}
          height={7.25}
          rx={3.625}
          transform="rotate(11.324 132.589 92.417)"
          fill="url(#f5d39f2jtu)"
        />
      </g>
      <g filter="url(#fc2764l6xv)">
        <rect
          x={142.079}
          y={45.027}
          width={65.247}
          height={7.25}
          rx={3.625}
          transform="rotate(11.324 142.079 45.027)"
          fill="url(#qxbufvgsmw)"
        />
      </g>
      <g filter="url(#3t2hwyjx7x)">
        <rect
          x={134.962}
          y={80.57}
          width={65.247}
          height={7.25}
          rx={3.625}
          transform="rotate(11.324 134.962 80.57)"
          fill="url(#x0l6usb4oy)"
        />
      </g>
      <g filter="url(#79xxua14bz)">
        <rect
          x={130.216}
          y={104.264}
          width={65.247}
          height={7.25}
          rx={3.625}
          transform="rotate(11.324 130.216 104.264)"
          fill="url(#oerdeeq6kA)"
        />
      </g>
    </g>
    <g filter="url(#g27odi9e9B)">
      <path
        d="m55.584 228.567 3.31-3.288.934-.929h.01l68.062-67.419c-6.076-8.466-9.69-18.8-9.69-29.995-.005-28.562 23.274-51.722 51.994-51.722s51.999 23.16 51.999 51.722-23.279 51.722-51.999 51.722c-10.643 0-20.531-3.187-28.77-8.65l-68.97 68.312-3.54 3.521c-2.265 2.257-7.094 1.117-10.78-2.546-3.683-3.668-4.83-8.466-2.565-10.723l.005-.005zM169.495 163.3c20.195 0 36.559-16.282 36.559-36.364 0-20.082-16.369-36.365-36.559-36.365-20.19 0-36.564 16.283-36.564 36.365s16.37 36.364 36.564 36.364z"
        fill="url(#7a8tikb8cC)"
      />
    </g>
    <defs>
      <linearGradient
        id="3n3fyd7bya"
        x1={1.717}
        y1={152.944}
        x2={418.112}
        y2={118.289}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="autv6wi1lc"
        x1={197.13}
        y1={53.98}
        x2={82.946}
        y2={53.055}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="pynsemxl7e"
        x1={199.624}
        y1={90.142}
        x2={85.44}
        y2={89.217}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="b4t4wwoqjg"
        x1={201.287}
        y1={114.251}
        x2={87.102}
        y2={113.325}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="8xd6ibtbni"
        x1={159.07}
        y1={66.034}
        x2={85.663}
        y2={65.652}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="karve70x5k"
        x1={161.564}
        y1={102.196}
        x2={88.157}
        y2={101.814}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="9ih557asrm"
        x1={163.226}
        y1={126.305}
        x2={89.819}
        y2={125.923}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="0a8pba9xwo"
        x1={66.036}
        y1={131.065}
        x2={482.431}
        y2={96.41}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="9hjoextykq"
        x1={253.347}
        y1={38.012}
        x2={139.163}
        y2={37.087}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="2ybgdiwmjs"
        x1={246.23}
        y1={73.555}
        x2={132.045}
        y2={72.629}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="f5d39f2jtu"
        x1={241.485}
        y1={97.25}
        x2={127.3}
        y2={96.325}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="qxbufvgsmw"
        x1={212.084}
        y1={49.86}
        x2={138.677}
        y2={49.477}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="x0l6usb4oy"
        x1={204.966}
        y1={85.403}
        x2={131.559}
        y2={85.02}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="oerdeeq6kA"
        x1={200.22}
        y1={109.097}
        x2={126.813}
        y2={108.715}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#fff" stopOpacity={0.17} />
      </linearGradient>
      <linearGradient
        id="7a8tikb8cC"
        x1={162.74}
        y1={86.843}
        x2={125.463}
        y2={221.515}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <filter
        id="tmoqtxx93b"
        x={83.463}
        y={37.392}
        width={111.297}
        height={23.759}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="3thav2ed8d"
        x={85.957}
        y={73.555}
        width={111.297}
        height={23.759}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="rr8aa7c3vf"
        x={87.619}
        y={97.663}
        width={111.297}
        height={23.759}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="qfot5e92xh"
        x={84.294}
        y={51.941}
        width={75.135}
        height={21.265}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="oi2arrg9aj"
        x={86.788}
        y={88.102}
        width={75.135}
        height={21.265}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="hgq8oktspl"
        x={88.45}
        y={112.211}
        width={75.135}
        height={21.265}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="yskqa6cxdn"
        x={81.717}
        y={0.443}
        width={195.2}
        height={242.155}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="ku9md2gkip"
        x={138.656}
        y={28.808}
        width={109.686}
        height={35.781}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="i1fhrbfdar"
        x={131.539}
        y={64.35}
        width={109.686}
        height={35.781}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="2169vrcq6t"
        x={126.794}
        y={88.045}
        width={109.686}
        height={35.781}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="fc2764l6xv"
        x={136.284}
        y={40.655}
        width={74.143}
        height={28.663}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="3t2hwyjx7x"
        x={129.167}
        y={76.198}
        width={74.143}
        height={28.663}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="79xxua14bz"
        x={124.421}
        y={99.893}
        width={74.143}
        height={28.663}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2.506} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10272"
          result="shape"
        />
      </filter>
      <filter
        id="g27odi9e9B"
        x={50.417}
        y={75.214}
        width={175.786}
        height={175.786}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1740_10272"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1740_10272"
          result="shape"
        />
      </filter>
    </defs>
  </motion.svg>
)

export default SvgComponent
